import { useEffect } from 'react'
import { logNavigation } from '../utils/firebaseUtils'

const useModalNavigationAnalytics = (modalOnTop: string) => {
	useEffect(() => {
		if (!modalOnTop) return

		logNavigation(modalOnTop)
	}, [modalOnTop])
}

export default useModalNavigationAnalytics
